module.exports = __webpack_public_path__ + "img/historia11.5ba49162.jpg";